import { z } from 'zod';
import { createModel, partySchema } from '../../common';
import { timelineEventType } from './timeline.event.model';
import { timelineTargetSchema } from './timeline.target.model';

/** `Timeline db model` */
export const TimelineSchema = createModel({
  event: timelineEventType,
  /** the target item/doc in which this event happens */
  target: timelineTargetSchema,
  /** this cloud be any string value that can be associated with the event such as
   * - stringified JSON
   * - email
   * - name
   * - etc
   * */
  value: z.coerce.string().optional(),
  /** the org that this event belongs to */
  org: partySchema.optional(),
  /** the user that created this action */
  user: partySchema.optional(),
});

/** `Timeline db model` */
export type Timeline = z.infer<typeof TimelineSchema.model>;
export type TimelineData = z.infer<typeof TimelineSchema.data>;
export type TimelinePartial = z.infer<typeof TimelineSchema.partial>;
